import { defineComponent as _defineComponent } from 'vue'
import { Attribute } from '@kodadot1/minimark/common'
import { emptyArray } from '~/utils/empty'
import CollapseCardWrapper from '@/components/shared/collapse/CollapseCardWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Properties',
  props: {
    attributes: { default: () => emptyArray<Attribute>() },
    fieldKey: { default: 'trait_type' }
  },
  setup(__props: any) {



return { __sfc: true,CollapseCardWrapper }
}

})